<template>
    <label id="togglestreetview" class="mdl-switch mdl-js-switch mdl-js-ripple-effect" for="switch-1">
        <input type="checkbox" id="switch-1" class="mdl-switch__input" v-model="svIsOn">
        <span class="mdl-switch__label">Turn on Streetview (instead of satellite)</span>
      </label>
      <iframe id="maps"
        width="300"
        height="225"
        frameborder="0" style="border:0"
        v-bind:src="iframeSrc" allowfullscreen>
    </iframe>
</template>

<script>
import Config from '../config.json';

export default {
  name: 'Maps',
  props: {
      coordinateX: {
          type: Number,
          default: 48.60,
      },
      coordinateY: {
          type: Number,
          default: 15.00,
      },
  },
  data() {
      return {
          iframeSrc: null,
          svIsOn: false,
          streetviewSrc: "https://www.google.com/maps/embed/v1/streetview?key=" + Config.API_KEY + "&location="+ this.coordinateX + "," + this.coordinateY +"&heading=210&pitch=10&fov=35",
          satelliteSrc: "https://www.google.com/maps/embed/v1/view?key=" + Config.API_KEY + "&center=" + this.coordinateX + "," + this.coordinateY + "&zoom=18&maptype=satellite",
      }
  },
  mounted: function (){
      this.iframeSrc = this.satelliteSrc
  },
  updated: function (){
      if(this.svIsOn){
            this.iframeSrc = this.streetviewSrc
        } else {
            this.iframeSrc = this.satelliteSrc
        }
  }
      
}
</script>

<style scoped>
#maps {
  width: 90%;
  margin: 5%;
}

#togglestreetview {
  margin: 5%;
  width: 80%;
}
</style>